module.exports = __webpack_public_path__ + "static/media/Vue-SDB_09-Gris-perle-manganese.316b61f2.jpg";